import {Component} from '@angular/core';
import {HelperProvider} from '../providers/helper.provider';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent {

  constructor(private helperProvider: HelperProvider) {
  }

  hide() {
    this.helperProvider.loading$.next(false);
  }
}
